import { dateStringToDisplayDate } from '../../utils/dateUtils'
import CountryFlag from '../CountryFlag/CountryFlag'
import UserIcon from '../Icons/UserIcon'
import { Customer } from './CustomerInfo'

const CustomerCard = ({ customer, countryCode }: { customer: Customer, countryCode: string | undefined }) => {

  return (
    <div className='flex items-center'>
      <div className='shrink-0'><UserIcon size='24px' /></div>
      <div className='pl-2'>
        <div className='customer-info__text-top customer-info__id mb-1 flex flex-wrap break-all items-center'><span className='mr-3'>Kund-id: {customer.id}</span>{countryCode && <CountryFlag countryCode={countryCode}/>}</div>
        {customer.latestActivity && <div className='customer-info__text-bottom mt-1'>Senaste aktivitet: {dateStringToDisplayDate(customer.latestActivity)}</div>}
      </div>
    </div>
  )
}

export default CustomerCard